import { IconButton } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { RiDeleteBinLine, RiFileEditLine } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import CTable from "../../../components/Table/table";
import { openCreateExamDataModel } from "../../../modules/admin-modules/models/Actions";
import { deleteExamRequest } from "../../../modules/superadmin-modules/exams/Actions";

const ExamsTable = ({ setAdd, setSelectedData }) => {
  const { exams, isLoading, publishLoading, restrictLoading } = useSelector(
    (state) => state.superadminExams
  );
  const user = useSelector((state) => state.user.userData);

  const dispatch = useDispatch();

  const [userRole, setUserRole] = useState("");

  const [offset, setPage] = useState(0);
  const [size, setPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [selected, setSelected] = useState({
    id: "",
  });

  useEffect(() => {
    if (user?.role?.length > 0) {
      setUserRole(user?.role[0]?.name);
    }
  }, [user?.role]);
  const viewData = (data) => {
    setSelectedData(data);
    setSelected(data);
  };
  const Data = exams?.map((data) => {
    return {
      ...data,
      buckets: data?.exam_buckets,
      edit: (
        <IconButton
          variant="outline"
          border="0"
          color="gray.600"
          aria-label="Call Sage"
          fontSize="20px"
          icon={<RiFileEditLine />}
          onClick={() => {
            setAdd(false);
            dispatch(openCreateExamDataModel());
          }}
        />
      ),
      delete: (
        <IconButton
          variant="outline"
          border="0"
          color="gray.600"
          aria-label="Call Sage"
          fontSize="20px"
          icon={<RiDeleteBinLine color="red" />}
          onClick={() => dispatch(deleteExamRequest(data?.id))}
        />
      ),
    };
  });
  const columns = [
    {
      Header: " الاختبار",
      accessor: "name",
    },
    {
      Header: "السنة الدراسية التابع له",
      accessor: "course.name",
    },
    {
      Header: "تعديل",
      accessor: "edit",
    },
    {
      Header: "حذف",
      accessor: "delete",
    },
  ];

  return (
    <CTable
      selectedData={viewData}
      Columns={columns}
      Data={Data}
      path={"openModel"}
      Actions
      Title={``}
      subTitle=""
      btnTitle=""
      placeHolder=""
      noSearchBar={true}
      noFilter={true}
      footerBtnTitle
      filterList
      addButton
      addButtonTitle=""
      setPage={setPage}
      setPerPage={setPerPage}
      currentpage={pageNumber}
      setPageNumber={setPageNumber}
      noSecondSearchBar={true}
      isLoading={isLoading}
      perPage={size}
      totalPage={Math.ceil(exams?.length / 10)}
    />
  );
};

export default ExamsTable;
